import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function RegistryListHeaderItem(props) {
	return (
		<div className={'h-full mb-4 mt-2 sm:mt-0 sm:mb-0 px-3 sm:px-0 sm:pl-4'}>
			<div
				className={'bg-bluegray-50 p-3 rounded-xl  border border-bluegray-100'}>
				<div className="flex items-center">
					<div className="text-3xl px-2">
						<FontAwesomeIcon
							className="text-gray-500 mr-2"
							icon={props.icon}></FontAwesomeIcon>
					</div>
					<div>
						<div className="flex">
							<div>
								<p className="text-xs">
									<span
										className={'uppercase font-semibold text-bluegray-700 text-xs'}>
										{props.label}
									</span>
								</p>
							</div>
						</div>
						<div className="flex">
							<p className={'text-regular font-bold text-primary-500'}>
								{props.value}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
